module.exports = __webpack_public_path__ + "media/images/bondform_bearhead3-f92f49cb113a06f5434f88c3d0997817.gif";